'use strict';

exports.__esModule = true;
exports.resolve = resolve;
exports.resolveWithPatterns = resolveWithPatterns;

var _Identifiers = require('../types/Identifiers');

var _ContextProps = require('../types/ContextProps');

var _TagTypes = require('../types/TagTypes');

var _resolvePayload = require('./resolvePayload');

var _sort = require('./sort');

var _buildOgImage2 = require('./build-og-image');

var _applyDefaultTags = require('../tags/defaults/apply-default-tags');

var _updateByIdentifier = require('../tags/values/update-by-identifier');

var _getByIdentifier = require('../tags/values/get-by-identifier');

var _fillInPatternBlob = require('../patterns/fill-in-pattern-blob');

function resolve(payload, context) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$withDefaults = _ref.withDefaults,
      withDefaults = _ref$withDefaults === undefined ? true : _ref$withDefaults;

  context = context || {};

  var result = (0, _resolvePayload.resolvePayload)(payload);
  var robots = (0, _getByIdentifier.getValueByIdentifier)(result.tags, _Identifiers.IDENTIFIERS.ROBOTS);

  if (robots === 'index') {
    result.tags = (0, _updateByIdentifier.updateValueByIdentifier)(result.tags, _Identifiers.IDENTIFIERS.ROBOTS, '');
  }

  if (withDefaults) {
    if (!robots && !isIndexable(context)) {
      result.tags = (0, _updateByIdentifier.updateValueByIdentifier)(result.tags, _Identifiers.IDENTIFIERS.ROBOTS, 'noindex');
    }

    result.tags = (0, _applyDefaultTags.applyDefaultTags)(result.tags, context).concat(getLink(context, _ContextProps.CONTEXT_PROPS.NEXT, 'next')).concat(getLink(context, _ContextProps.CONTEXT_PROPS.PREV, 'prev'));
  }

  result.tags = applyOgImageModifications(result.tags);
  result.tags = (0, _sort.sort)(result.tags);
  return result;
}

function resolveWithPatterns(payload, context) {
  context = context || {};
  var result = (0, _resolvePayload.resolvePayload)(payload);
  var robots = (0, _getByIdentifier.getValueByIdentifier)(result.tags, _Identifiers.IDENTIFIERS.ROBOTS);

  if (robots === 'index') {
    result.tags = (0, _updateByIdentifier.updateValueByIdentifier)(result.tags, _Identifiers.IDENTIFIERS.ROBOTS, '');
  }

  if (!robots && !isIndexable(context)) {
    result.tags = (0, _updateByIdentifier.updateValueByIdentifier)(result.tags, _Identifiers.IDENTIFIERS.ROBOTS, 'noindex');
  }

  result.tags = result.tags.concat(getLink(context, _ContextProps.CONTEXT_PROPS.NEXT, 'next')).concat(getLink(context, _ContextProps.CONTEXT_PROPS.PREV, 'prev'));

  result = (0, _fillInPatternBlob.fillInPatternBlob)(result, context);
  result.tags = applyOgImageModifications(result.tags);
  result.tags = (0, _sort.sort)(result.tags);

  return result;
}

function applyOgImageModifications(tags) {
  var OG_IMAGE = _Identifiers.IDENTIFIERS.OG_IMAGE,
      OG_IMAGE_WIDTH = _Identifiers.IDENTIFIERS.OG_IMAGE_WIDTH,
      OG_IMAGE_HEIGHT = _Identifiers.IDENTIFIERS.OG_IMAGE_HEIGHT;

  var _buildOgImage = (0, _buildOgImage2.buildOgImage)(tags),
      src = _buildOgImage.src,
      width = _buildOgImage.width,
      height = _buildOgImage.height;

  return [[OG_IMAGE, src], [OG_IMAGE_WIDTH, width], [OG_IMAGE_HEIGHT, height]].reduce(function (acc, curr) {
    var identifier = curr[0],
        value = curr[1];

    return value ? (0, _updateByIdentifier.updateValueByIdentifier)(acc, identifier, value) : acc;
  }, tags);
}

function getLink(context, name, rel) {
  if (context[name]) {
    return [{
      type: _TagTypes.TAG_TYPES.LINK,
      props: {
        rel: rel,
        href: context[name]
      }
    }];
  }
  return [];
}

function isIndexable(context) {
  return context[_ContextProps.CONTEXT_PROPS.INDEX_SITE] && context[_ContextProps.CONTEXT_PROPS.INDEX_PAGE];
}